import { setStorage, getStorage } from './onStorage'
// 获取url全部参数
export const getUrlAllParams = (urlStr?: string) => {
  const { hash } = window.location
  const paramsObj: { [key: string]: string } = {}
  if (!urlStr) {
    const isQuestion = hash.includes('?')
    if (isQuestion) urlStr = hash.split('?')[1]
    if (!isQuestion) return false
  }
  urlStr = decodeURIComponent(urlStr || '')
  const urlStrArr = urlStr.split('&')
  urlStrArr.forEach((el) => {
    const key = el.split('=')[0]
    const value = el.split(`${key}=`)[1]
    paramsObj[key] = value
  })
  return paramsObj
}

export const getUrlParam = (name: string, searchStr?: any): string | null => {
  const { search, hash } = window.location

  const hashSearch = hash.split('?')[1]

  searchStr = searchStr || search.substr(1) || hash.split('?')[1] || ''
  if (hashSearch) searchStr += `${searchStr ? '&' : ''}${hashSearch}`
  if (searchStr.indexOf('?') !== -1) searchStr = searchStr.split('?')[1]
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = searchStr.match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

type keyType = string
interface GetValueFnOption {
  // 是否需要存缓存，触发条件如果url可以获取到值并且的不等于缓存的值，
  saveStorage?: boolean
  // 存缓存的key，默认等于key
  saveKey?: string
  // 默认值，当url和缓存拿不到值，默认复制这个
  defaultVal?: any
  // 缓存的类型
  storageType?: 'session' | 'local'
}

interface GetValueFn {
  (key: keyType, option?: GetValueFnOption): string
}

/**
 *  获取orgflag 平台码 用户id,如果获取过一次就直接从这里拿，不走拿缓存等，节约资源
 * @param key
 * @param option @GetValueFnOption
 * @returns string
 */
export const getValue: GetValueFn = (key: keyType, option = {}) => {
  const { saveStorage = true, saveKey = key, defaultVal = '' } = option || {}
  const urlVal = getUrlParam(key)
  const storeVal = getStorage(saveKey, { ...option })
  const value = urlVal || storeVal || defaultVal

  // 如果需要保存缓存，并且url的值和缓存的值不一致的情况存缓存
  if (saveStorage && urlVal && urlVal !== storeVal) {
    setStorage(saveKey, value, { ...option })
  }
  return value
}

// 获取token
export const getToken = (key: string) => {
  return getValue(key)
}

// 获取userType
export const getUserType = () => {
  return getValue('userType', {
    storageType: 'session',
  })
}
/**
 *  获取是否过期，会拿当前时间做判断，
 * @param startTime  开始时间，会拿这个时间加上要过期的时间，再和现在的时间做对比
 * @param endTimer  多久后结束的单位，毫秒做单位，默认是30分钟  30*60*1000
 * @returns true过期  false没过期
 */
export const getIsExpire = (
  startTime: number | string,
  endTimer?: number,
): boolean => {
  const now = new Date().getTime()
  const expireTime = endTimer || 30 * 60 * 1000
  // 现在时间大于存token时间+过期时间
  const isExpire = now > Number(startTime) + expireTime
  return isExpire
}
